import type { Guide } from '../data/accommodation-guides';

import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';


interface GuideSidebarProps {
  guides: Guide[];
  selectedId: string;
  onSelect: (id: string) => void;
}

export function GuideSidebar({ guides, selectedId, onSelect }: GuideSidebarProps) {
  return (
    <>
      {/* Mobile: dropdown */}
      <div className="lg:hidden">
        <Select value={selectedId} onValueChange={onSelect}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {guides.map((guide) => (
              <SelectItem key={guide.id} value={guide.id}>
                {guide.title}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Desktop: sidebar list */}
      <nav className="hidden space-y-1 lg:block">
        {guides.map((guide) => (
          <Button
            key={guide.id}
            variant="ghost"
            className={cn(
              'w-full justify-start',
              guide.id === selectedId && 'bg-primary/10 text-primary',
            )}
            onClick={() => onSelect(guide.id)}
          >
            {guide.title}
          </Button>
        ))}
      </nav>
    </>
  );
}
